export default "__VITE_ASSET__BOvaN_Iw__"